import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { LockGlyph12Icon } from 'assets/icons'

const ResourceListItemCard = ({
   coverMedia,
   dateAdded,
   linkTo,
   name,
   privacy,
   subtitle,
   summary,
   textColor
}) => (
   <Link to={linkTo}>
      <View display="flex">
         <View flex="0 0 auto" width="60px">
            <View
               paddingTop="100%"
               backgroundColor="#eee"
               backgroundImage={coverMedia && `url(${coverMedia?.file.thumbnailUrlW480})`}
               backgroundSize="cover"
               backgroundPosition="center center"
               backgroundRepeat="no-repeat"
               borderRadius="3px"
               marginBottom="15px[a-d] 20px[e-f]"
            />
         </View>
         <View flex="1 1 auto" paddingLeft="15px">
            <Text
               size="2"
               lineHeight="120%"
               weight="medium"
               color={textColor}>
               {name}
            </Text>
            {(subtitle || summary) && (
               <View
                  margin="5px 0px"
                  maxHeight="55px[a-d] 55px[e-f]"
                  style={{
                     overflow: 'hidden',
                     textOverflow: 'ellipsis',
                     wordBreak: 'break-word'
                  }}>
                  <Text
                     size="2"
                     lineHeight="130%"
                     color="#888">
                     {subtitle}
                     {!subtitle && (
                        <div
                           dangerouslySetInnerHTML={{
                              __html: summary
                           }}
                        />
                     )}
                  </Text>
               </View>
            )}
            <View marginTop="5px[e-f]">
               <Text size="1.5" color="#aaa" letterSpacing="-0.3px">
                  {dateAdded}
               </Text>
            </View>
            {['admin', 'draft', 'private'].includes(privacy) && (
               <View
                  display="inline-flex"
                  alignItems="center"
                  backgroundColor={privacy === 'draft'
                     ? 'rgba(247, 183, 124, 1)'
                     : 'rgba(0,0,0,0.3)'
                  }
                  borderRadius="2px"
                  padding="5px 5px"
                  marginTop="5px">
                  {privacy !== 'draft' && (
                     <View display="flex" alignItems="center" marginRight="5px">
                        <LockGlyph12Icon
                           color="rgba(255,255,255,0.5)"
                           width="7px"
                           height="7px"
                        />
                     </View>
                  )}
                  <Text
                     size="0.7"
                     lineHeight="100%"
                     color={privacy === 'draft' ? '#000' : 'rgba(255,255,255,0.8)'}
                     weight="medium"
                     transform="uppercase">
                     {privacy}
                  </Text>
               </View>
            )}
         </View>
      </View>
   </Link>
)

ResourceListItemCard.propTypes = {
   coverMedia: PropTypes.object,
   dateAdded: PropTypes.string.isRequired,
   linkTo: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   privacy: PropTypes.string.isRequired,
   subtitle: PropTypes.string,
   summary: PropTypes.string,
   textColor: PropTypes.string.isRequired
}

ResourceListItemCard.defaultProps = {
   coverMedia: undefined,
   subtitle: undefined,
   summary: undefined
}

export default ResourceListItemCard
